<template>
  <div class="bodywarp">
    <el-card class="box-card boxcard" style="min-height:calc(100% - 30px)">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="公司名称">
          <el-select v-model="formInline.companyname" clearable placeholder="请选择">
            <el-option v-for="item in selectlist" :key="item.ccorpname" :label="item.ccorpname" :value="item.ccorpname"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物料名称">
          <el-input v-model="formInline.cinvname" placeholder="物料名称"></el-input>
        </el-form-item>

        <el-form-item>
          <Debounce :time='300' :isDebounce="1">
            <el-button type="primary" @click.native="GetBilledList" size="medium">查询</el-button>
          </Debounce>
          <el-button type="primary" size="medium" @click="exportExcel()">导出</el-button>
        </el-form-item>

        <el-button type="success" size="medium" @click="ListRead()" style="float:right">数据更新</el-button>

      </el-form>
      <div class="text item text-center">

        <el-table :data="tableData" style="width: 100%" id="out-table" class="tablecenter" border :cell-style="{ padding: '7px 0'}" :header-cell-style="{ background: '#eef1f6' }">
          <el-table-column prop="ccorpname" label="公司名称" width="260"></el-table-column>
          <el-table-column prop="cinvcode" label="物料编码" width="120"></el-table-column>
          <el-table-column prop="cinvname" label="物料名称" width="260"></el-table-column>
          <el-table-column prop="cunit" label="计量单位" width="80"></el-table-column>
          <el-table-column prop="islabs" label="入库量" width="120"></el-table-column>
          <el-table-column prop="inumber" label="消耗量" width="120"></el-table-column>
          <el-table-column prop="ikc" label="库存量" width="120"></el-table-column>
          <el-table-column prop="cdeliverylot" label="批次" width="120"></el-table-column>
          <el-table-column prop="dproducdate" label="生产日期" width="120" :formatter="formatData"></el-table-column>
          <el-table-column prop="ishelflife" label="保质期" width="120"></el-table-column>
          <el-table-column prop="ddqtime" label="预计到期时间" width="120" :formatter="formatData"></el-table-column>
        </el-table>
        <div class="pull-right" style="padding:20px;">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10,20, 50, 100, 1000]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
          </el-pagination>
        </div>
      </div>
    </el-card>

  </div>
</template>

<script>
import FileSaver from "file-saver";
import XLSX from "xlsx";
import moment from 'moment';
export default {
  data() {
    return {
      formInline: {
        companyname: "",
        cpoid: "",
        cinvname: "",
      },
      tableData: [],
      // 牧场
      selectlist: {},
      // 分页
      pageSize: 10,
      pageIndex: 1,
      // 页数
      totalCount: 0,
    };
  },
  created() {
    this.GetBilledList();
    this.GetAccountInfo();
  },
  methods: {
    //定义导出Excel表格事件
    exportExcel() {
      /* 从表生成工作簿对象 */
      var wb = XLSX.utils.table_to_book(document.querySelector("#out-table"), {
        raw: true,
      });
      /* 获取二进制字符串作为输出 */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(
          //Blob 对象表示一个不可变、原始数据的类文件对象。
          //Blob 表示的不一定是JavaScript原生格式的数据。
          //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
          //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
          new Blob([wbout], { type: "application/octet-stream" }),
          //设置导出文件名称
          "寄售库存.xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },

    // 获取table 信息
    GetBilledList() {
      // console.log(this.formInline);

      this.$axios({
        method: "post",
        url: "CommonModule/Op_SupplierDD/ConsignmentInventoryList ",
        //data: this.formInline,
        data: {
          ccorpname: this.formInline.companyname,
          cinvname: this.formInline.cinvname,
          pageSize: this.pageSize,
          pageIndex: this.pageIndex,
        },
      }).then((res) => {
        if (res.data.Data.rows) {
          this.tableData = res.data.Data.rows;
          this.totalCount = res.data.Data.totalCount;
        }
      });
    },
    // 获取公司信息
    GetAccountInfo() {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_StoreAndInvoice/GetAccountInfo",
      }).then((res) => {
        console.log(res);
        if (res.data.Success) {
          if (res.data.Message) {
            this.selectlist = res.data.Data;
          }
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },

    //  数据更新
    ListRead() {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_SupplierDD/ConsignmentInventoryList_Read ",
      }).then((res) => {
        console.log(res);
        if (res.data.Success) {
          this.$message.success(res.data.Message);
          this.GetBilledList();
          this.GetAccountInfo();
        }
      });
    },

    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetBilledList();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetBilledList();
    },
    //转换时间
    formatData(row,column){
      let dataTime = row[column.property];
      if(dataTime){
        let timeData =  moment(dataTime);
        return timeData.format("YYYY-MM-DD");
      }else{
        return null;
      }
    },
  },
};
</script>


